import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            gruppiItems: [],
            gruppoPathResource: "/gruppi",
        };
    },
    methods: {
        gruppiLoadData() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.gruppoPathResource;
            this.gruppiItems = [];
            axios.get(link)
                .then((response) => {
                    this.gruppiItems = response.data.data;
                    this.closeShowModalLoading();
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    this.$bvToast.toast("Errore nel leggere dati: " + error.message, {
                        title: "",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
    },
};
